import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';


const color = "rgba(0, 0, 0, .225)";


const styles = {
    trackStyle: { backgroundColor: color },
    handleStyle: {
        borderColor: color,
        backgroundColor: "white",
        opacity: 1,
    },
    dotStyle: { borderColor: color, }
};
const YearSlider = (props) => {

    const min = 1970;
    const max = 2022;
    return <>
        <Slider {...props} trackStyle={styles.trackStyle} dotStyle={styles.dotStyle} handleStyle={styles.handleStyle} />
    </>;
};

export default YearSlider;